<template>
    <div class="pic-wrap">
        <div class="header-return" v-if="picFrom!='noReturn'">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <h2>{{picName}}</h2>
        </div>
        <div>
            <el-tabs tab-position="left" @tab-click="handleClick" v-model="picTabSel">
                <template v-for="item in picTabList">
                    <el-tab-pane :label="item.name" :name="picType+item.type">
                        <div class="pic-btn-wrap">
                            <p style="font-size: 12px;margin-right: 20px;" @click="centerDialogVisible = true">配置<i class="el-icon-question"></i></p>

                            <p>*可拖拽排序图片</p>
                            <el-button type="success" @click="addProduct(item.limitCount)" class="header-btn" icon="el-icon-plus"></el-button>
                            <el-button type="danger" @click="delProductAllPic()" class="header-btn">清除所有图片</el-button>
                        </div>
                        <div class="drag-container">
                            <table class="drag-container">
                                <thead>
                                <tr>
                                    <th width="60">序号</th>
                                    <th>名称</th>
                                    <th>图片</th>
                                    <th>操作</th>
                                </tr>
                                </thead>
                                <draggable v-model="picData" tag="tbody" @change="changeListSort">
                                    <tr v-for="(item,index) in picData">
                                        <td>{{index+1}}</td>
                                        <td>{{item.picName}}</td>
                                        <td>
                                            <el-image
                                                style="width: 100px; max-height: 200px"
                                                :src="item.fullRelativeUrl"
                                                :preview-src-list="[item.fullRelativeUrl]">
                                            </el-image>
<!--                                            <img :src="item.fullRelativeUrl">-->
                                        </td>
                                        <td><el-button type="danger" size="mini" @click="delProPic(item)">删除</el-button></td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>
                    </el-tab-pane>
                </template>
            </el-tabs>
        </div>
        <picDialog :proId="this.proId" :picType="picTabSel"></picDialog>
        <el-dialog
                title="提示"
                :visible.sync="centerDialogVisible"
                width="30%"
                center>
            <div>
                5块钱活动图片配置(促销商品上传)<br/>
                1、详情页大图------5块钱邀请页头图(只传一张)<br/>
                2、首页列表图------5块钱关注页图片<br/>
                3、营养图----------5块钱邀请页邀请按钮图<br/>
                4、长期订购图-------只传两张 no1:5块钱的右上角规则入口;no2:弹窗活动的规则图<br/>
                5、小图-------------产品订单缩略图<br/>
                6、详情页图----------5块钱邀请页一系列图(注意: 第2张图对应兑换按钮点击图)<br/>
                7、推荐图-------5块钱首页一系列图片(注意: 第2张图、倒数第2张对应按钮点击图)<br/>
                <hr/>
                回收活动图片配置<br/>
                1、详情页大图------乐纯游乐园-活动首页图片<br/>
                2、首页列表图------我的计划页图片<br/>
                3、营养图----------我的计划列表图片<br/>
                4、推荐图-------回收须知<br/>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import picDialog from '@/components/pic_dialog/pic_list'
    import draggable from 'vuedraggable'
    export default{
        data(){
            return {
                picTabSel:this.$route.query.picType+'1',
                picType:this.$route.query.picType,
                picName:this.$route.query.picName||this.$route.query.activeName||'',
                picFrom:this.$route.query.picFrom,
                proId:this.$route.params.id||this.$route.query.proId||this.$route.query.activeNo,
                dialogFormVisiblePicAdd:false,
                centerDialogVisible: false
            }
        },
        computed:{
            picData:{
                get:function(){
                    return this.$store.getters.getPicture
                },
                set:function(val){
                    console.log(val)
                    this.$store.commit('INIT_PICTURE',val)
                }
            },
            picTabList:function () {
                return this.$store.state.picList.productPicTabs
            }
        },
        components:{
            picDialog,
            draggable
        },
        mounted(){
            this.handleClick();
        },
        methods:{
            handleClick(){
                this.$store.dispatch('initPicture',{proId:this.proId,picType:this.picTabSel})
            },
            addProduct(limit){
                if(limit<=this.picData.length){
                    this.$message({
                        showClose: true,
                        message: "最多上传" + limit + "个",
                        type: 'error'
                    });
                    return;
                }
                this.$store.commit('SET_PIC_DIALOG',true)
            },
            delProductAllPic(){
                const _this = this;
                this.$confirm('清除该商品/活动的所有图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center:true,
                    type: 'warning'
                }).then(() => {
                    _this.$store.dispatch('clearProductPic',{proId: row.proId,picType:this.picType}).then((res) => {
                        if (res.status == 200) {
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.handleClick()
                        } else {
                            _this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    _this.$message({
                        showClose: true,
                        message: '取消删除',
                        type: 'error'
                    });
                })
            },
            delProPic(row){
                const _this = this;
                this.$confirm('删除图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center:true,
                    type: 'warning'
                }).then(() => {
                    _this.$store.dispatch('delProImg',{picId: row.picId}).then((res) => {
                        if (res.status == 200) {
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.handleClick()
                        } else {
                            _this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    _this.$message({
                        showClose: true,
                        message: '取消删除',
                        type: 'error'
                    });
                })
            },
            returnHistory(){
                window.history.back()
            },
            changeListSort(evt){
                console.log(evt.moved)
                let moveItem = evt.moved;
                this.$store.dispatch('changePicListSort',{picId:moveItem.element.picId,sort:moveItem.newIndex+1,proId:this.proId,picType:this.picTabSel})
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .pic-wrap{
        padding: 10px;
    }
    .header-return{
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
        position: relative;
        h2{
            text-align: center;
            position: absolute;
            left: 50%;
            top:0;
            margin: 0;
        }
    }
    .pic-btn-wrap{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        p{
            color: #e50011;
            font-size: 20px;
            margin: 0;
        }
    }
    .header-btn{
        margin-left: 20px;
        font-size: 24px;
        font-weight: bold;
        padding: 5px 10px;
    }
    .drag-container{
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        img{
            width: 70px;
            height: 70px;
        }
        td,th{
            padding: 12px 0;
            border:1px solid #EBEEF5;

        }
        th{
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/picture.vue